import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Reativar conta ")
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "flex md6" }
const _hoisted_4 = { class: "flex md6" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "flex md6" }
const _hoisted_7 = { class: "flex md6" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "flex md6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "px-2" }, "Endereço", -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "flex md6" }
const _hoisted_13 = { class: "flex md2" }
const _hoisted_14 = { class: "flex md4" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "flex md6" }
const _hoisted_17 = { class: "flex md6" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "flex md6" }
const _hoisted_20 = { class: "flex md3" }
const _hoisted_21 = { class: "flex md3" }
const _hoisted_22 = { class: "mdo-select" }
const _hoisted_23 = { for: "country" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", { value: "BR" }, " Brasil ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", { value: "ES" }, " Espanha ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", { value: "PT" }, " Portugal ", -1)
const _hoisted_27 = [
  _hoisted_24,
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "px-2" }, "Configurações", -1)
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "flex md4" }
const _hoisted_31 = { class: "flex md4" }
const _hoisted_32 = { class: "flex md4" }
const _hoisted_33 = {
  key: 0,
  class: "flex"
}
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Reativar conta ")
const _hoisted_35 = {
  key: 1,
  class: "flex"
}
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Desativar conta ")

import {
  Account,
  AccountCreateInput,
  AccountFlags,
  AccountResponse,
  AccountUpdateInput,
  AddressInput,
} from "@/codes/gen/types";
import {AccountService} from "@/codes/services/AccountService";
import {ReactiveData} from "@/codes/types/MDOTypes";
import {ROUTE_NAMES} from "@/codes/util/constants";
import {Confirm} from "@/codes/util/swalUtil";
import router from "@/router";
import Swal from "sweetalert2";
import {useForm} from "vee-validate";
import {onMounted, reactive, ref} from "vue";
import {useI18n} from "vue-i18n";
import {useRoute} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isEdit = ref(false);
let idAccountEdit = '';
const account = reactive<ReactiveData<AccountCreateInput>>({ data: { address: {} as AddressInput, flags: {activate12Med: false, activateVouchers: false, activateCheckSaasStatus: false} as AccountFlags } as AccountCreateInput });
const accountInfos = reactive<ReactiveData<Account>>({});
const service = new AccountService();


const form = useForm();
const formMeta = reactive(form.meta);

const i18n = useI18n();

const makeData = function (result: Account) {
  return {
    name: result.name,
    cnpj: result.cnpj,
    email: result.email,
    phone: result.phone,
    whatsapp: result.whatsapp,
    address: {
      city: result.address?.city,
      country: result.address?.country,
      complement: result.address?.complement,
      number: result.address?.number,
      district: result.address?.district,
      postcode: result.address?.postcode,
      state: result.address?.state,
      street: result.address?.street,
    },
    flags: {
      activate12Med: result.flags?.activate12Med,
      activateVouchers: result.flags?.activateVouchers,
      activateCheckSaasStatus: result.flags?.activateCheckSaasStatus
    }
  }
}

const loadAccount = async function(id: string) {
  const result = await service.get(id);
  if (result) {
    const clearedData: AccountCreateInput = makeData(result)
    account.data = clearedData;
    accountInfos.data = result;
    form.setValues(clearedData);
  }
}
const funcConcluir = (result: AccountResponse | null | undefined) => {
  if (result && result.data.id) {
    idAccountEdit = '';
    router.push({ name: ROUTE_NAMES.accounts });
  } else {
    Swal.fire({
      title: i18n.t('genericErrorTitle'),
      text: i18n.t('saveErrorMessage', { register: i18n.t('account.title'), message: result?.message })
    });
  }
}


const save = async function() {
  const validate = await form.validate() as any;

    if(!validate.valid){
      form.setErrors(validate.errors);
      return;
    }

    const mData: AccountUpdateInput = {...account.data, whatsapp: account.data.whatsapp && account.data.whatsapp.length < 13 && account.data.address?.country === 'BR' ? `+55${account.data.whatsapp}` : account.data.whatsapp};

    if (isEdit.value) {
      const result = await service.update(idAccountEdit, mData);
      funcConcluir(result);
    } else {
      const result = await service.save(mData as AccountCreateInput);
      funcConcluir(result);
    }

}

const cancel = function() {
  if (form.meta.value.dirty) {
    Confirm.fire({
      title: i18n.t('form.confirmCancelTitle'),
      text: i18n.t('form.confirmCancelText')
    })
    .then((result) => {
      if (result.isConfirmed) {
        router.push({ name: ROUTE_NAMES.accounts });
      }
    });
  } else {
    router.push({ name: ROUTE_NAMES.accounts });
  }
}


function loadResource() {
  const route = useRoute();

  if (route && route.name === ROUTE_NAMES.editAccount) {
    idAccountEdit = route.params.id as string;
    loadAccount(idAccountEdit);
    isEdit.value = true;
  }
}
const doRemove = async function() {
  const result = await service.remove(accountInfos.data.id);
  if (result && result.data) {
    loadAccount(accountInfos.data.id);
  }
}
const doRestore = async function() {
  const result = await service.restore(accountInfos.data.id);
  if (result && result.data) {
    loadAccount(accountInfos.data.id);
  }
}
function restore() {
  Confirm.fire({
    title: "Reativar conta",
    text: `Deseja realmente reativar a conta ${account.data?.name}`
  })
      .then((result) => {
        if (result.isConfirmed) {
          doRestore();
        }
      })
}

function remove() {
  Confirm.fire({
    title: "Desativar conta",
    text: `Deseja realmente desativar a conta ${account.data?.name}`
  })
      .then((result) => {
        if (result.isConfirmed) {
          doRemove();
        }
      })
}

onMounted(() => {
  loadResource()
})


return (_ctx: any,_cache: any) => {
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_alert = _resolveComponent("va-alert")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_VField = _resolveComponent("VField")!
  const _component_va_divider = _resolveComponent("va-divider")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_va_checkbox = _resolveComponent("va-checkbox")!
  const _component_base_form = _resolveComponent("base-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_form, {
      "form-meta": _unref(formMeta),
      onSave: save,
      onCancel: cancel
    }, {
      actions: _withCtx(() => [
        (_unref(account).data.deletedAt)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createVNode(_component_va_button, {
                icon: "fas fa-repeat",
                color: "info",
                size: "medium",
                onClick: _cache[17] || (_cache[17] = ($event: any) => (restore()))
              }, {
                default: _withCtx(() => [
                  _hoisted_34
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (!_unref(account).data.deletedAt)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _createVNode(_component_va_button, {
                icon: "fas fa-trash",
                color: "warning",
                size: "medium",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (remove()))
              }, {
                default: _withCtx(() => [
                  _hoisted_36
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        (_unref(accountInfos).data?.deletedAt)
          ? (_openBlock(), _createBlock(_component_va_alert, {
              key: 0,
              color: "warning",
              closeable: "",
              title: "CONTA INATIVA",
              icon: "warning",
              center: "",
              class: "mb-6"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, "Esta conta foi desativada em " + _toDisplayString(_unref(accountInfos).data?.deletedAt.transform) + ". Você pode ativar esta conta para voltar a utilizá-la.", 1),
                _createVNode(_component_va_button, {
                  icon: "fas fa-repeat",
                  color: "info",
                  size: "medium",
                  class: "mt-4 mb-2",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (restore()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(accountInfos).data?.disabledBySaas)
          ? (_openBlock(), _createBlock(_component_va_alert, {
              key: 1,
              color: "danger",
              closeable: "",
              title: "CONTA INATIVA NA SAAS",
              icon: "warning",
              center: "",
              class: "mb-6"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_unref(accountInfos).data?.disabledBySaas), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_VField, {
              name: "name",
              rules: 'required|min:3'
            }, {
              default: _withCtx(({ field, errors: nameErrors }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(account).data.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(account).data.name = $event)),
                  class: "mb-4",
                  label: _ctx.$t('register.name'),
                  error: nameErrors && nameErrors.length > 0,
                  "error-messages": nameErrors
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_VField, {
              name: "cnpj",
              rules: 'required|min:14'
            }, {
              default: _withCtx(({ field, errors: cnpjError }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(account).data.cnpj,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_unref(account).data.cnpj = $event)),
                  class: "mb-4",
                  label: _ctx.$t('account.cnpj'),
                  error: cnpjError && cnpjError.length > 0,
                  "error-messages": cnpjError,
                  mask: { numericOnly: true, delimiters: [ '.', '.', '/', '-' ], blocks: [2, 3, 3, 4, 2] }
                }), null, 16, ["modelValue", "label", "error", "error-messages", "mask"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_VField, {
              name: "email",
              rules: 'email'
            }, {
              default: _withCtx(({ field, errors: emailError }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(account).data.email,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_unref(account).data.email = $event)),
                  class: "mb-4",
                  label: _ctx.$t('register.email'),
                  error: emailError && emailError.length > 0,
                  "error-messages": emailError
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_VField, {
              name: "phone",
              rules:  _unref(account).data.address?.country === 'PT' ? 'min:10' : 'min:9' 
            }, {
              default: _withCtx(({ field, errors: phoneError }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(account).data.phone,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_unref(account).data.phone = $event)),
                  class: "mb-4",
                  label: _ctx.$t('register.phone'),
                  error: phoneError && phoneError.length > 0,
                  "error-messages": phoneError,
                  messages: "Ex: +5544988776655, +34999999999 ou +351987654321"
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            }, 8, ["rules"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_VField, {
              name: "whatsapp",
              rules:  _unref(account).data.address?.country === 'PT' ? 'min:10' : 'min:9' 
            }, {
              default: _withCtx(({ field, errors: whatsappErrors }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(account).data.whatsapp,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_unref(account).data.whatsapp = $event)),
                  class: "mb-4",
                  label: _ctx.$t('register.whatsapp'),
                  error: whatsappErrors && whatsappErrors.length > 0,
                  "error-messages": whatsappErrors,
                  messages: "Ex: +5544988776655, +34999999999 ou +351987654321"
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            }, 8, ["rules"])
          ])
        ]),
        _createVNode(_component_va_divider, { orientation: "left" }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_VField, {
              name: "street",
              rules: 'min:6'
            }, {
              default: _withCtx(({ field, errors: streetErrors }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(account).data.address.street,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_unref(account).data.address.street = $event)),
                  class: "mb-4",
                  label: _ctx.$t('address.street'),
                  error: streetErrors && streetErrors.length > 0,
                  "error-messages": streetErrors
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_VField, { name: "number" }, {
              default: _withCtx(({ field, errors: numberErrors }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(account).data.address.number,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_unref(account).data.address.number = $event)),
                  class: "mb-4",
                  label: _ctx.$t('address.number'),
                  error: numberErrors && numberErrors.length > 0,
                  "error-messages": numberErrors
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_VField, {
              name: "postcode",
              rules: 'min:8'
            }, {
              default: _withCtx(({ field, errors: postcodeErrors }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(account).data.address.postcode,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_unref(account).data.address.postcode = $event)),
                  class: "mb-4",
                  label: _ctx.$t('address.postcode'),
                  error: postcodeErrors && postcodeErrors.length > 0,
                  "error-messages": postcodeErrors,
                  mask: { numericOnly: true, delimiter: '-', blocks: [5, 3] }
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_VField, {
              name: "district",
              rules: 'min:6'
            }, {
              default: _withCtx(({ field, errors: districtErrors }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(account).data.address.district,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_unref(account).data.address.district = $event)),
                  class: "mb-4",
                  label: _ctx.$t('address.district'),
                  error: districtErrors && districtErrors.length > 0,
                  "error-messages": districtErrors
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_VField, {
              name: "complement",
              rules: 'min:6'
            }, {
              default: _withCtx(({ field }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(account).data.address.complement,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_unref(account).data.address.complement = $event)),
                  class: "mb-4",
                  label: _ctx.$t('address.complement')
                }), null, 16, ["modelValue", "label"])
              ]),
              _: 1
            }),
            _createVNode(_component_ErrorMessage, { name: "complement" })
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_VField, {
              name: "city",
              rules: 'min:3'
            }, {
              default: _withCtx(({ field, errors: cityErrors }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(account).data.address.city,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_unref(account).data.address.city = $event)),
                  class: "mb-4",
                  label: _ctx.$t('address.city'),
                  error: cityErrors && cityErrors.length > 0,
                  "error-messages": cityErrors
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_VField, {
              name: "state",
              rules: 'min:2'
            }, {
              default: _withCtx(({ field, errors: stateErrors }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(account).data.address.state,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_unref(account).data.address.state = $event)),
                  class: "mb-4",
                  label: _ctx.$t('address.state'),
                  error: stateErrors && stateErrors.length > 0,
                  "error-messages": stateErrors
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('address.country')), 1),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_unref(account).data.address.country = $event)),
                name: "country"
              }, _hoisted_27, 512), [
                [_vModelSelect, _unref(account).data.address.country]
              ])
            ])
          ])
        ]),
        _createVNode(_component_va_divider, { orientation: "left" }, {
          default: _withCtx(() => [
            _hoisted_28
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_va_checkbox, {
              modelValue: _unref(account).data.flags.activate12Med,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_unref(account).data.flags.activate12Med = $event)),
              class: "mb-4",
              label: "Habilitar 12MED"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_va_checkbox, {
              modelValue: _unref(account).data.flags.activateVouchers,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_unref(account).data.flags.activateVouchers = $event)),
              class: "mb-4",
              label: "Habilitar Voucher"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_va_checkbox, {
              modelValue: _unref(account).data.flags.activateCheckSaasStatus,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_unref(account).data.flags.activateCheckSaasStatus = $event)),
              class: "mb-4",
              label: "Verificar situação Saas"
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["form-meta"])
  ]))
}
}

})